import Logger from '../lib/logger';

class SimpleCarousel extends HTMLElement {

  constructor() {
    super();
		this.NAME = `SimpleCarousel`;
    let template = document.getElementById('simple-carousel-template');
    let templateContent = template.content;
    //
    this.abortController;
    this.slides = this.querySelectorAll('[slot^="slide-"]');
    this.slides.forEach((el) => el.style.visibility = 'hidden');
    this.style.visibility = 'hidden';
    this.length = this.slides.length;
    this.maxVisible = 3;
    this.max = this.length - 1;
    this.indexBtns = [];
    this.curIndex = 0;
    this.duration = 400;
    this.timeThreshhold = 100;
    this.swipeThreshhold = 50;
    this.swipeStart = 0;
    this.swipeTimeBegin = 0;
    this.swiping = false;
    this.showDirectionalBtns = true;
    this.showIndexBtns = false;
    this.smallIndexBtns = false;
    this.mobileWidthImportant = '!important';
    this.noClones = this.hasAttribute('no-clones');
    //
    const align = this.getAttribute('slides-align');
    /* console.log('align',align); */
    if (!this.noClones && this.length > 1) {
      this.clones = [
        this.slides[0].cloneNode(true),
        this.slides[1].cloneNode(true),
        align === 'left' && this.slides[2] ? this.slides[2].cloneNode(true) : null,
        align === 'left' && this.slides[3] ? this.slides[3].cloneNode(true) : null,
        this.slides[this.max].cloneNode(true),
        this.slides[this.max - 1] ? this.slides[this.max - 1].cloneNode(true) : null,
      ];
      this.clones = this.clones.filter(el => el);
      const i = align === 'left' && this.length >= 4 ? 4 : 2;
      const x = align === 'left' && this.length >= 4 ? this.length + 5 : this.length + 3;
      this.clones[i].style.transform = `translateX(${(x) * -100}%)`;
      this.clones[i+1].style.transform = `translateX(${(x + 2) * -100}%)`;
      this.clones.forEach((el, i) => {
        el.setAttribute('slot', `slide-clone-${i + 1}`);
        this.appendChild(el);
      });
    }
    //
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(templateContent.cloneNode(true));
    //
    this.main = this.shadowRoot.querySelector('main');
    this.containerShadowDom = this.shadowRoot.querySelector('[data-carousel-container]');
    this.containerShadowDom.style.width = `${100 / this.maxVisible}%`;
    if (this.hasAttribute('mobile-width-important')) this.containerShadowDom.setAttribute('mobile-width-important', 'true');
    this.slidesShadowDom = this.shadowRoot.querySelector('[data-carousel-slides]');
    this.directionalBtns = this.shadowRoot.querySelectorAll('[data-carousel-btn][data-dir]');
    this.directionalBtnContainer = this.directionalBtns[0].parentElement;
    this.customButtons = this.querySelectorAll('[slot="custom-btns"] [data-carousel-btn][data-dir]');
    this.indexBtnContainer = this.shadowRoot.querySelector('[data-carousel-index-btns]');
    //
		Logger.info(`${this.NAME} > constructor`);
  }

  connectedCallback() {
		Logger.info(`${this.NAME} > connectedCallback`);
		this.init();
  }

  disconnectedCallback() {
		Logger.info(`${this.NAME} > disconnectedCallback`);
		this.kill();
  }

  static get observedAttributes() {
    return [
      'duration', 
      'max-visible', 
      'show-index-buttons',
      'small-index-buttons', 
      'show-directional-buttons', 
      'row-gap', 
      'data-cur-index', 
      'slides-align',
      'theme'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
		Logger.info(`${this.NAME} > attributeChangedCallback, ${name} ${newValue}`);
    //
    if (name === 'duration') {
      const dur = parseInt(newValue);
      if (!isNaN(dur)) this.duration = dur;
		}
    //
    if (name === 'max-visible') {
      const mv = parseInt(newValue);
      if (!isNaN(mv)) {
        this.maxVisible = mv;
        this.main.dataset.maxVisible = mv;
        this.containerShadowDom.style.width = `${100 / this.maxVisible}%`;
        if (!(this.maxVisible%2)) {
          this.shadowRoot.querySelectorAll('[slot^="slide-"]').forEach((el) => el.style.transform = 'translateX(-50%)');
        } else {
          this.shadowRoot.querySelectorAll('[slot^="slide-"]').forEach((el) => el.style.transform = null);
        }
      } 
		}
    //
    if (name === 'show-index-buttons') {
      this.showIndexBtns = newValue !== 'false' || newValue !== '';
      this.indexBtnContainer.dataset.show = this.showIndexBtns;
      this.indexBtnContainer.dataset.showFor = newValue;
		}
    //
    if (name === 'small-index-buttons') {
      this.smallIndexBtns = newValue === 'true';
      this.indexBtnContainer.dataset.show = this.showIndexBtns;
		}
    //
    if (name === 'show-directional-buttons') {
      this.showDirectionalBtns = newValue === 'true';
      this.directionalBtnContainer.dataset.show = this.showDirectionalBtns;
		}
    //
    if (name === 'row-gap') {
      this.main.style.rowGap = newValue;
		}
    //
    if (name === 'data-cur-index') {
      const idx = parseInt(newValue);
      if (!isNaN(idx) && idx !== this.curIndex) {
        this.onIndexBtn(idx)
      }
        
		}
    //
    if (name === 'slides-align') {
      this.containerShadowDom.dataset.align = newValue;
		}
    //
    if (name === 'theme') {
      this.main.dataset.theme = newValue;
		}
  }

  init() {
    Logger.info(`${this.NAME} > init`);
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    //
    this.querySelectorAll('[slot^="slide-"]').forEach((el) => el.style.visibility = null);
    this.style.visibility = null;
    //
    if (this.duration)  {
      this.slidesShadowDom.style.transition = `transform ${this.duration}ms ease-out`;
      this.slidesShadowDom.style.transform = 'translate3d(0%,0%,0)';
    }
    //
    if (this.showDirectionalBtns) {
      this.directionalBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => this.onDirBtn(e.target.dataset.dir), { signal });
      });
    }
    //
    if (this.customButtons) {
      this.shadowRoot.querySelector('[name="custom-btns"]').dataset.show = 'true';
      this.customButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => this.onDirBtn(e.target.dataset.dir), { signal });
      });
    }
    //
    if (this.showIndexBtns) {
      this.slides.forEach((s, i) => {
        const btn = document.createElement('BUTTON');
        btn.dataset.carouselDot = 'true';
        btn.dataset.index = i;
        btn.dataset.active = i ? 'false' : 'true';
        btn.title = `go to slide ${i + 1}`;
        btn.addEventListener('click', (e) => this.onIndexBtn(parseInt(e.target.dataset.index), { signal }));
        if (this.smallIndexBtns) btn.dataset.small = 'true';
        this.indexBtnContainer.appendChild(btn);
        this.indexBtns.push(btn)
      });
    }
    //
    if (!this.hasAttribute('no-swipe')) {
      this.addEventListener('touchstart', (e) => this.onTouchStart(e.changedTouches[0].clientX, e.timeStamp), { signal });
      this.addEventListener('touchend', (e) => this.onTouchEnd(e.changedTouches[0].clientX, e.timeStamp), { signal });
      this.addEventListener('touchmove', (e) => {
        this.onTouchMove(e.changedTouches[0].clientX);
        e.preventDefault();
      }, { signal, passive: false });
    }
  }

  onDirBtn(dir) {
    if (this.slidesShadowDom.style.transitionDuration === '0s') return;
    const index = dir === 'right' ? this.curIndex + 1 : this.curIndex - 1;
    const idx = index > this.max ? 0 : (index < 0 ? this.max : index);
    this.updateIndexBtns(idx, dir);
    //
    if (index > this.max && this.clones) {
      setTimeout(() => {
        this.curIndex = 0;
        this.slidesShadowDom.style.transitionDuration = '0s';
        this.slidesShadowDom.style.transform = 'translate3d(0%,0%,0)';
        setTimeout(() => {
          this.slidesShadowDom.style.transitionDuration = `${this.duration}ms`;
        }, 40);
      }, this.duration);
    } else if (index === -1) {
      setTimeout(() => {
        this.curIndex = this.max;
        this.slidesShadowDom.style.transitionDuration = '0s';
        this.slidesShadowDom.style.transform = `translate3d(${this.curIndex * -100}%,0,0)`;
        setTimeout(() => {
          this.slidesShadowDom.style.transitionDuration = `${this.duration}ms`;
        }, 40);
      }, this.duration);
    }
    //
    this.curIndex = index;
    if (this.clones) this.slidesShadowDom.style.transform = `translate3d(${this.curIndex * -100}%,0,0)`;
  }

  onIndexBtn(index) {
    this.curIndex = index;
    this.updateIndexBtns(this.curIndex);
    if (this.clones) {
      this.slidesShadowDom.style.transform = `translate3d(${this.curIndex * -100}%,0,0)`;
    }
  }

  updateIndexBtns(index, dir) {
    if (this.indexBtns.length) {
      this.indexBtns.forEach((btn) => btn.dataset.active = 'false');
      this.indexBtns[index].dataset.active = 'true';
    }
    this.dispatchEvent(new CustomEvent('index-change', { detail: {index, direction: dir}}));
  }

  onTouchStart(clientX, timeStamp) {
    this.containerShadowDom.style.transitionDuration = '0s';
    this.swipeStart = clientX;
    this.swipeTimeBegin = timeStamp;
    this.swiping = true;
  }

  onTouchEnd(clientX, timeStamp) {
    this.swiping = false;
    this.containerShadowDom.style.transitionDuration = '0.24s';
    this.containerShadowDom.style.transform = `translate3d(0%,0,0)`;
    const amount = this.swipeStart - clientX;
    const time = timeStamp - this.swipeTimeBegin;
    if (time > this.timeThreshhold && Math.abs(amount) >= this.swipeThreshhold) {
      this.onDirBtn(amount > 0 ? 'right' : 'left');
      this.swipeStart = 0;
      this.swipeTimeBegin = 0;
    }
  }

  onTouchMove(clientX) {
    if (this.swiping) {
      const percent = Math.round(this.swipeStart - clientX) / 10;
      this.containerShadowDom.style.transform = `translate3d(${-percent}%,0,0)`;
    }
  }

  kill() {
    Logger.info(`${this.NAME} > kill`);
    this.curIndex = 0;
    this.abortController.abort();
    this.abortController = null;
    this.indexBtns.forEach((btn) => btn.parentElement.removeChild(btn));
    this.slidesShadowDom.style = undefined;
    this.containerShadowDom.style.transform = null;
    this.containerShadowDom.style.transitionDuration = null;
  }
}

customElements.define('simple-carousel', SimpleCarousel);
